import { Component, ViewEncapsulation, inject, signal } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { ConfirmationService, PrimeTemplate } from "primeng/api";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { AbstractListController } from "src/app/common/abstract-list.component";
import { Rooms } from "src/app/models/rooms";
import { forkJoin, map, switchMap } from "rxjs";
import { RoomsService } from "src/app/services/rooms.service";
import { RoomsImagesService } from "src/app/services/rooms_images.service";
import { Bookings } from "src/app/models/bookings";
import { PARAM_ROOMS_PATH } from "../../constants/constants";
import { environment } from "src/environments/environment";
import { Bind } from "primeng/bind";
import { Drawer } from "primeng/drawer";

import { FormsModule } from "@angular/forms";
import { InputText } from "primeng/inputtext";
import { Select } from "primeng/select";
import { ButtonDirective } from "primeng/button";
import { TableModule } from "primeng/table";
import { Tag } from "primeng/tag";
import { NgxPaginationModule } from "ngx-pagination";
import { ConfirmDialog } from "primeng/confirmdialog";
import { NgxSpinnerComponent } from "ngx-spinner";

import { DynamicFiltersComponent } from "../../components/dynamic-filters/dynamic-filters.component";
import { TPipe } from "../../i18n/t.pipe";
import { opt } from "../../i18n/i18n";
@Component({
    standalone: true,
    selector: "app-manage-rooms",
    templateUrl: "./manage-rooms.component.html",
    styleUrl: "./manage-rooms.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, DynamicFiltersComponent, Bind, Drawer, PrimeTemplate, FormsModule, InputText, Select, ButtonDirective, RouterLink, TableModule, Tag, NgxPaginationModule, ConfirmDialog, NgxSpinnerComponent, CurrencyPipe]
})
export class ManageRoomsComponent extends AbstractListController<
  Rooms,
  any
> {
  protected roomsService: RoomsService;
  protected confirmationService: ConfirmationService;

  title = "Camere";
  readonly cols = signal<{ field: string; header: string }[]>(undefined);
  readonly columnOptions = signal<{ label: string; value: any }[]>(undefined);
  readonly selectedColumns = signal<any[]>(undefined);
  readonly roomDialog = signal<boolean>(false);
  readonly room = signal<Rooms>(undefined);
  booking: Bookings;
  readonly selectedWorks = signal<any[]>(undefined);
  imgPath = environment.imageUrl;
  protected isLoading: boolean = false;

  constructor() {
    const roomsService = inject(RoomsService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      roomsService,
      confirmationService,
      router,
      route,
      PARAM_ROOMS_PATH
    );
    this.roomsService = roomsService;
    this.confirmationService = confirmationService;

    this.cols.set([{ field: "title", header: "Nome" }]);
    this.colsFilter.set([
      { field: "title", icon: "pi-home", header: "Nome", type: "string" },
      { field: "code", icon: "pi-tag", header: "Codice", type: "string" },
      {
        field: "is_active",
        icon: "pi-power-off",
        header: "Stato",
        type: "select",
        option: [
          opt("non attiva", "0"),
          opt("attiva", "1"),
        ],
      },
      { field: "max_capacity", icon: "pi-users", header: "Ospiti max", type: "number" },
      { field: "price_base", icon: "pi-euro", header: "Prezzo base", type: "number" },
    ]);

    this.columnOptions.set([]);
    this.selectedColumns.set([]);
    for (let i = 0; i < this.cols().length; i++) {
      this.columnOptions.update((a) => { a.push({
        label: this.cols()[i].header,
        value: this.cols()[i],
      }); return [...a]; });
    }
  }

  open(room: Rooms) {
    this.router.navigate([this.path + "edit", room.id]);
  }

  bands(room: any): { label: string; price: string; free: boolean }[] {
    let raw = room?.children_ranges;
    if (typeof raw === "string") {
      try {
        raw = JSON.parse(raw);
      } catch {
        raw = [];
      }
    }
    return (Array.isArray(raw) ? raw : [])
      .map((b: any) => ({ min: Number(b.min), max: Number(b.max), price: Number(b.price) }))
      .sort((a, b) => a.min - b.min)
      .map((b) => ({
        label: b.min === b.max ? `${b.min} anni ` : `${b.min}-${b.max} anni `,
        price: b.price > 0 ? ` ${b.price.toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })}` : " gratis",
        free: !(b.price > 0),
      }));
  }

  edit(room: Rooms) {
    this.room.set({ ...room });

    if (this.room() && this.room().works_id) {
      this.selectedWorks.set(this.room().works_id.split(","));
    }

    this.roomDialog.set(true);
  }
}
